import React from 'react';
import { render } from 'react-dom';
import App from './jsx/app';
import 'scss/main';

render(<App />, document.getElementById('app'));
